module.exports = __webpack_public_path__ + "static/Quote 4 - Mobile-5a0c784c4064253dffd7d64251ebf02b.png";